class BuilderNotifyModal extends HTMLElement {
  constructor() {
    super();
    this.delay = this.dataset.delay ? parseInt(this.dataset.delay, 10) : 200;
  }

  connectedCallback() {
    // Initialize all the elements
    this.openBtn = this.querySelector('[data-modal-open]');
    this.closeBtn = this.querySelector('[data-notify-modal-close]');
    this.content = this.querySelector('[data-notify-modal-content]');
    this.contentID = this.content ? this.content.getAttribute("id") : null;
    this.emailInput = this.querySelector('[data-modal-email]');
    this.notifyMsg = this.querySelector('[data-pre-success-msg]');
    this.invalidText = this.querySelector('[data-email-invalid]');
    this.innerContent = this.querySelector('[data-inner-content]');
    this.notifyButton = this.querySelector('[data-notify-button]');
    this.emailSection = this.querySelector('[data-email-form-section]');
    this.marketingCheckbox = this.querySelector('[data-marketing-checkbox]');
    this.variantId = this.openBtn ? this.openBtn.getAttribute('data-notify-variant-id') : null;
    this.productId = this.openBtn ? this.openBtn.getAttribute('data-notify-product-id') : null;
    this.variantTitle = this.openBtn ? this.openBtn.getAttribute('data-notify-title') : null;

    // Success variables
    this.preMsgOne = this.querySelector('[data-success-msg-1]');
    this.preMsgTwo = this.querySelector('[data-success-msg-2]');
    this.bigClose = this.querySelector('[data-button-big-close]');
    this.checkCircle = this.querySelector('[data-success-circle]');
    this.successClose = this.querySelector('[data-button-big-close]');

    // Move modal to body immediately after component connects
    this.moveModalToBody();

    // Set up event listeners
    this.setupEventListeners();
  }

  moveModalToBody() {
    // Only move if we have a modal content element
    if (!this.content) return;

    // Check if modal container exists at body level
    let modalContainer = document.getElementById('notify-modal-container');
    if (!modalContainer) {
      modalContainer = document.createElement('div');
      modalContainer.id = 'notify-modal-container';
      modalContainer.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 99999;
        pointer-events: none;
      `;
      document.body.appendChild(modalContainer);
    }

    // Move the modal content to the body-level container
    if (this.content.parentElement !== modalContainer) {
      // Clone the modal content to preserve event listeners
      const modalClone = this.content.cloneNode(true);

      // Remove the original from DOM
      this.content.remove();

      // Add the clone to the body container
      modalContainer.appendChild(modalClone);

      // Update our reference to the new element
      this.content = modalClone;

      // Re-query all child elements since we cloned
      this.closeBtn = this.content.querySelector('[data-notify-modal-close]');
      this.emailInput = this.content.querySelector('[data-modal-email]');
      this.notifyMsg = this.content.querySelector('[data-pre-success-msg]');
      this.invalidText = this.content.querySelector('[data-email-invalid]');
      this.innerContent = this.content.querySelector('[data-inner-content]');
      this.notifyButton = this.content.querySelector('[data-notify-button]');
      this.emailSection = this.content.querySelector('[data-email-form-section]');
      this.marketingCheckbox = this.content.querySelector('[data-marketing-checkbox]');
      this.preMsgOne = this.content.querySelector('[data-success-msg-1]');
      this.preMsgTwo = this.content.querySelector('[data-success-msg-2]');
      this.bigClose = this.content.querySelector('[data-button-big-close]');
      this.checkCircle = this.content.querySelector('[data-success-circle]');

      // Make sure the modal content can receive pointer events when visible
      this.content.style.pointerEvents = 'auto';
    }
  }

  setupEventListeners() {
    if (this.openBtn) {
      this.openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.open();
      });
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      });
    }

    if (this.bigClose) {
      this.bigClose.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      });
    }

    if (this.notifyButton) {
      this.notifyButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleNotifySubmit();
      });
    }
  }

  open() {
    if (!this.content) return;

    this.sliderArrows = document.querySelectorAll('.slider-arrow');

    // Ensure the container is visible
    const container = this.content.parentElement;
    if (container) {
      container.style.pointerEvents = 'auto';
    }

    // Show the modal
    this.content.classList.replace('hidden', 'flex');

    // Trigger opacity transition
    requestAnimationFrame(() => {
      this.content.classList.remove('opacity-0');
    });

    this.toggleSliderArrows(false);

    // Set up close handlers
    this.windowClickHandler = (e) => this.handleBodyClick(e);
    this.escapeHandler = (e) => {
      if (e.key === 'Escape') this.close();
    };

    window.addEventListener('click', this.windowClickHandler);
    window.addEventListener('keydown', this.escapeHandler);
  }

  close() {
    if (!this.content) return;

    this.content.classList.add('opacity-0');

    setTimeout(() => {
      this.content.classList.replace('flex', 'hidden');
      if (this.invalidText) {
        this.invalidText.classList.add('hidden');
      }

      // Hide the container
      const container = this.content.parentElement;
      if (container) {
        container.style.pointerEvents = 'none';
      }
    }, this.delay);

    this.toggleSliderArrows(true);

    // Clean up event listeners
    if (this.windowClickHandler) {
      window.removeEventListener('click', this.windowClickHandler);
    }
    if (this.escapeHandler) {
      window.removeEventListener('keydown', this.escapeHandler);
    }
  }

  handleNotifySubmit() {
    const email = this.emailInput.value;
    const isValidEmail = /^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/.test(email);
    const marketingConsent = this.marketingCheckbox.checked;

    if (isValidEmail) {
      this.recordNotify(email, marketingConsent);

      // Update all email inputs on the page
      document.querySelectorAll("[data-modal-email]").forEach((emailInput) => {
        emailInput.value = email;
      });
    } else {
      if (this.invalidText) {
        this.invalidText.classList.remove('hidden');
      }
    }
  }

  recordNotify(email, marketingConsent) {
    $.ajax({
      type: "POST",
      url: "https://app.restockrocket.io/api/v1/intents.json",
      data: JSON.stringify({
        "intent": {
          "shopify_variant_id": this.variantId,
          "shopify_product_id": this.productId,
          "channel": "email",
          "quantity": 1,
          "source": "api"
        },
        "customer": {
          "email": email,
          "accepts_marketing": marketingConsent
        },
        "product": {
          "title": this.variantTitle,
          "variant_count": 1,
          "variant_title": this.variantTitle
        }
      }),
      headers: {
        "X-Shopify-Shop-Domain": "rammount.myshopify.com",
        "Content-Type": "application/json"
      },
      success: () => {
        setTimeout(() => {
          if (this.notifyButton) this.notifyButton.classList.add('hidden');
          if (this.notifyMsg) this.notifyMsg.classList.add('hidden');
          if (this.emailSection) this.emailSection.classList.add('hidden');
          if (this.preMsgOne) this.preMsgOne.classList.remove('hidden');
          if (this.preMsgTwo) this.preMsgTwo.classList.remove('hidden');
          if (this.checkCircle) this.checkCircle.classList.remove('hidden');
          if (this.bigClose) this.bigClose.classList.remove('hidden');
        }, this.delay);
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.error('Notify request failed:', textStatus, errorThrown);
      }
    });
  }

  handleBodyClick(e) {
    // Don't close if clicking inside the modal or on the open button
    if (this.innerContent && !this.innerContent.contains(e.target) &&
        !e.target.closest('[data-modal-open]') &&
        !e.target.closest('[data-inner-content]')) {
      this.close();
    }
  }

  toggleSliderArrows(show) {
    if (this.sliderArrows && this.sliderArrows.length > 0) {
      this.sliderArrows.forEach(arrow => {
        arrow.style.display = show ? 'block' : 'none';
      });
    }
  }

  disconnectedCallback() {
    // Clean up when component is removed
    if (this.windowClickHandler) {
      window.removeEventListener('click', this.windowClickHandler);
    }
    if (this.escapeHandler) {
      window.removeEventListener('keydown', this.escapeHandler);
    }
  }
}

customElements.define('builder-notify-modal', BuilderNotifyModal);
